module.exports = __webpack_public_path__ + "static/media/400075_02.df715e6f.png";